import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";

const initialFormState = {
  from_date: "",
  today_date: "",
  location: "",
};

function FetchLogsModal({ show, handleClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [formData, setFormData] = useState(initialFormState);

  const fetchLocations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/users/add-new-device/`, {
        headers: HEADERS,
      });

      const results = res.data?.results || [];

      const uniqueLocations = [
        ...new Set(results.map((d) => d.location).filter(Boolean)),
      ];

      setLocations(uniqueLocations);
    } catch {
      toast.error("Failed to load locations");
    }
  };

  useEffect(() => {
    if (show) {
      fetchLocations();
    }
  }, [show]);

  useEffect(() => {
    if (!show) {
      setFormData(initialFormState);
      setLocations([]);
      setLoading(false);
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFetchLogs = async () => {
    const { from_date, today_date, location } = formData;

    if (!from_date || !today_date || !location) {
      toast.error("All fields are required");
      return;
    }

    if (new Date(from_date) > new Date(today_date)) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        `${BASE_URL}/users/attendance/fetch_device_logs/`,
        formData,
        { headers: HEADERS },
      );

      toast.success("Logs fetched successfully");
      handleClose();
      onSuccess?.();
    } catch {
      toast.error("Failed to fetch logs");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Fetch Device Logs</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <div className="row mb-3">
          <div className="col-6">
            <Form.Group>
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                name="from_date"
                value={formData.from_date}
                onChange={handleChange}
                size="sm"
              />
            </Form.Group>
          </div>

          <div className="col-6">
            <Form.Group>
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                name="today_date"
                value={formData.today_date}
                onChange={handleChange}
                size="sm"
              />
            </Form.Group>
          </div>
        </div>

        <Form.Group>
          <Form.Label>Location</Form.Label>
          <Form.Select
            name="location"
            value={formData.location}
            onChange={handleChange}
            size="sm"
          >
            <option value="">Select Location</option>
            {locations.length > 0 ? (
              locations.map((loc, index) => (
                <option key={index} value={loc}>
                  {loc}
                </option>
              ))
            ) : (
              <option disabled>No locations found</option>
            )}
          </Form.Select>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleFetchLogs} disabled={loading}>
          {loading ? "Fetching..." : "Fetch Logs"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FetchLogsModal;
